<script setup>

import { inject } from 'vue';
import ListeImports from './listeImports/ListeImports.vue';
import DetailImport from './detailImport/DetailImport.vue';

const { imports } = defineProps({
  imports: Array
});

const selectionSchema = inject('selectionSchema');

</script>

<template>
	<div class="panel-lateral contenu-onglet-schema">
		<ListeImports 
			:imports="imports" />
		<DetailImport 
			v-if="selectionSchema.import" 
			:importDonnees="selectionSchema.import" />
	</div>
</template>

<style scoped>
</style>